import { Loader } from '@servicetitan/web-components';

export interface TenantTimeZoneModel {
    Name?: string;
    IanaName: string;
    UtcOffset: number;
}

export function App() {
    /* // Uncomment the following code to test with the MFE data
       // Also, change the return value of GetRoutingUrl in src/utils/api-url-util.ts to the API url
       const timezeone: TenantTimeZoneModel = {
           Name: 'Pacific Standard Time',
           IanaName: 'America/Los_Angeles',
           UtcOffset: -5,
       }; */

    /* const data = useMemo(() => {
           return {
               platform: 'ST',
               timezone: timezeone,
               useTenantTimeZone: true,
           };
       }, [timezeone]); */
    
    /* return (
           <>
               <h3 style={{color: 'red'}}>Running in MFE</h3>
               <Loader data={data} src="http://localhost:8889" loadingFallback={<FallbackLoader/>} loadingFallbackDelayed/>
           </>
       ) */
    return <Loader src="/@servicetitan/routing-frontend" />;
}